import { useState, useEffect } from "react";

function useMediaNavigation(totalPages, loading = false) {
    const [currentPage, setCurrentPage] = useState(0);

    useEffect(() => {
        if (!loading) {
            setCurrentPage(0);
        }
    }, [totalPages, loading]);

    const goNext = () => {
        setCurrentPage((prev) => Math.min(prev + 1, totalPages - 1));
    };

    const goPrev = () => {
        setCurrentPage((prev) => Math.max(prev - 1, 0));
    };

    return { currentPage, goNext, goPrev };
}

export default useMediaNavigation;